//@ts-ignore
import { tw } from "@careinfo/tailwind";

import { Link, useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import Card from "../reusable/Card";
import { useForm } from "react-hook-form";
import ComboboxInput from "../reusable/ComboboxInput";
import RemoteChargeTable from "./RemoteChargeTable";
import CreateIcon from "../../Icons/CreateIcon";
const RemoteArea = (props: any) => {
  const { id, templateID } = useParams();

  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({});

  const localServiceBranch = watch("origin");

  return (
    <>
      <Card title={`Rate List`}>
        <div className={tw`w-full grid grid-cols-3 gap-x-6`}>
          <ComboboxInput
            url={APIS.LOCATION_LIST}
            props={{ level: 0, is_active: true }}
            queryKey={"country"}
            register={register("origin")}
            errors={errors?.origin}
            name={"origin"}
            label={"Origin Country"}
            setValue={setValue}
            placeholder={"Search Country"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Card>
      <Link
        to={"create"}
        className={tw`focus:outline-none flex w-28 items-center gap-x-2 bg-primary-light px-3 py-2 mb-2 rounded text-primary`}
      >
        <CreateIcon color={"var(--primary)"} />
        Add New
      </Link>
      <Card title={`Rate Format`}>
        {localServiceBranch ? (
          <RemoteChargeTable
            localServiceBranch={localServiceBranch}
            merchantId={null}
            delivery_charge_template={templateID}
            id={id}
          />
        ) : (
          <>
            {" "}
            <p>Please select Country </p>
          </>
        )}
      </Card>
    </>
  );
};

export default RemoteArea;
